import { __extends } from "tslib";
import * as React from 'react';
import { ScrollableBarInner } from './inner-bar';
import { namespacedClassnames } from '../../common';
import ResizeObserver from 'resize-observer-polyfill';
export var scrollableBarKey = 'scrollable-bar-wrapper';
var ScrollableBar = /** @class */ (function (_super) {
    __extends(ScrollableBar, _super);
    function ScrollableBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            elementsWidth: 0,
            viewportWidth: _this.props.viewportWidth
        };
        _this.contentElement = React.createRef();
        _this.wrapper = React.createRef();
        _this.observer = null;
        _this.updateBarWidth = function (elementsWidth) {
            return elementsWidth !== _this.state.elementsWidth && _this.setState({ elementsWidth: elementsWidth });
        };
        _this.widthChanged = function () {
            if (!_this.props.viewportWidth && _this.wrapper.current) {
                _this.setState({ viewportWidth: _this.wrapper.current.clientWidth });
            }
        };
        return _this;
    }
    ScrollableBar.prototype.componentDidMount = function () {
        var _this = this;
        var target = this.contentElement.current &&
            this.contentElement.current.getRootNode &&
            this.contentElement.current.getRootNode();
        var config = { attributes: true, childList: true, subtree: true };
        var callback = function () {
            return _this.updateBarWidth(_this.contentElement.current && _this.contentElement.current.clientWidth || 1000);
        };
        if (target) {
            this.observer = new MutationObserver(callback);
            this.observer.observe(target, config);
        }
        if (this.wrapper.current && ResizeObserver) {
            try {
                this.resizeObserver = new ResizeObserver(function () { return _this.widthChanged(); });
                this.resizeObserver.observe(this.wrapper.current);
            }
            catch (e) {
                // tslint:disable-next-line: no-console
                console.error(e);
            }
        }
    };
    ScrollableBar.prototype.componentWillUnmount = function () {
        if (this.observer) {
            this.observer.disconnect();
        }
    };
    ScrollableBar.prototype.render = function () {
        var _a = this, props = _a.props, contentElement = _a.contentElement, state = _a.state;
        return (React.createElement("div", { className: namespacedClassnames('scrollable-bar', props.className), style: { maxWidth: props.viewportWidth || '100%' }, ref: this.wrapper },
            React.createElement(ScrollableBarInner, { contentSize: this.state.elementsWidth, viewportWidth: state.viewportWidth, className: props.className },
                React.createElement("div", { className: namespacedClassnames('bar-elements', scrollableBarKey), ref: contentElement }, props.children))));
    };
    return ScrollableBar;
}(React.PureComponent));
export { ScrollableBar };
//# sourceMappingURL=index.js.map